import React from 'react';
import { Button } from '@lifeomic/chroma-react/components/Button';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { Text } from '@lifeomic/chroma-react/components/Text';
import surveyUrls from '@lifeomic/phc-web-toolkit/src/components/Surveys/util/surveyUrls';
import NotificationHelper from '@lifeomic/phc-web-toolkit/src/redux/util/NotificationHelper';
import { surveysActions } from '../../redux/modules/surveys';
import { contextKeys } from '../../redux/modules/asyncRequestContexts';

export const REOPEN_WARNING =
  'Reopening this completed response lets you correct it and complete it again. When you complete it, the clinic note in Elation is replaced. If a physician has signed that note, this removes the signature, and the corrected note goes back to Requiring Action for a new signature.';

export const REOPEN_FAILURE =
  'Could not reopen this survey. The completed response was not changed.';

export const reopenCompletedResponse = (
  response: fhir.QuestionnaireResponse,
  amendmentId: string,
): fhir.QuestionnaireResponse => {
  const extension = (response.extension || []).filter(
    item => item.url !== surveyUrls.surveyResponseAmendment,
  );
  extension.push({
    url: surveyUrls.surveyResponseAmendment,
    valueString: amendmentId,
  });
  return {
    ...response,
    status: 'in-progress',
    extension,
  };
};

/**
 * Saves the reopened response through the same request every other survey
 * save uses (it carries the active cohort, which cohort-scoped staff need).
 * Resolves true only when the save landed; a failure shows an error toast.
 */
export const saveReopenedResponse =
  (reopened: fhir.QuestionnaireResponse) =>
  async (dispatch: any): Promise<boolean> => {
    const result = await dispatch(
      surveysActions.updateSurveyResponse(
        reopened,
        contextKeys.surveys.updateSurveyResponse,
        new NotificationHelper(null, REOPEN_FAILURE),
      ),
    );
    return Boolean(result) && !result.error;
  };

export const ReopenCompletedSurveyDialog: React.FC<{
  isOpen: boolean;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ isOpen, isSubmitting = false, onCancel, onConfirm }) => (
  <Modal
    isOpen={isOpen}
    title="Reopen completed survey?"
    onDismiss={onCancel}
    actions={
      <>
        <Button variant="text" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? 'Reopening…' : 'Reopen survey'}
        </Button>
      </>
    }
  >
    <Text>{REOPEN_WARNING}</Text>
  </Modal>
);
